module.exports = __webpack_public_path__ + "img/esport-banner.499b7c4c.svg";